module.exports = __webpack_public_path__ + "img/arrow-left.e70ca332.svg";